import React from "react";
import { IconButton, Stack, Typography, styled, Tooltip } from "@mui/material";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { MdArrowBack } from "@react-icons/all-files/md/MdArrowBack";
import { MdRefresh } from "@react-icons/all-files/md/MdRefresh";
import { MdHome } from "@react-icons/all-files/md/MdHome";

import { useTranslation } from "react-i18next";

const ErrorContainer = styled(Stack)`
  margin-top: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

// This is Error Boundary Component which can be passed to error param in Route config
function Error() {
  const { t } = useTranslation();
  const error = useRouteError();
  const navigate = useNavigate();

  let errorMessage = "Unknown";
  let errorDetail = "";

  if (isRouteErrorResponse(error)) {
    errorMessage = `${error.status} ${error.statusText}`;
    errorDetail = error.data?.message;
  }

  return (
    <ErrorContainer>
      <Typography variant="h1">{"Oops!"}</Typography>
      <Typography variant="body1">
        {t("error_boundary_message", {
          defaultValue: "Sorry an unexpected error has occurred",
        })}
      </Typography>
      <Typography variant="body2">{errorMessage}</Typography>
      {errorDetail && <Typography variant="body2">{errorDetail}</Typography>}
      <Stack direction="row" spacing={2}>
        {/* <Tooltip title="Back">
          <IconButton aria-label="back" onClick={() => navigate(-1)}>
            <MdArrowBack />
          </IconButton>
        </Tooltip> */}
        <Tooltip title="Home">
          <IconButton aria-label="home" onClick={() => navigate("/")}>
            <MdHome />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title="Refresh">
          <IconButton aria-label="refresh" onClick={() => navigate(0)}>
            <MdRefresh />
          </IconButton>
        </Tooltip> */}
      </Stack>
    </ErrorContainer>
  );
}

export default Error;
